import React from 'react';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { loadAndExecuteRecaptcha } from '../../../../utils/recaptcha_helpers';

const createReactClass = require('create-react-class');

const MapDownloadButton = createReactClass({
  getInitialState() {
    return {
      recaptchaReady: false
    };
  },
  componentDidMount() {
    if (this.props.setRemoteRef) {
      this.props.setRemoteRef(this.showDownloadModal);
    }
  },
  showWithCaptcha() {
    loadAndExecuteRecaptcha('downloadRoute', recaptchaToken => {
      // Need to use our window.messagingTunnel to ask the containing window to display the modal colorbox?
      if (this.props.useMessagingChannel) {
        this.props.useMessagingChannel.publish({
          topic: 'trail.download.modal',
          data: {
            colorboxOptions: jQuery => this.colorboxOptions(jQuery, recaptchaToken)
          }
        });
      } else {
        jQuery.colorbox(this.colorboxOptions(jQuery, recaptchaToken));
      }
    });
  },
  showDownloadModal() {
    // Delay loading script until now since it shows the ugly Recaptcha logo upon loading
    if (this.state.recaptchaReady) {
      this.showWithCaptcha();
    } else if (typeof grecaptcha !== 'undefined') {
      this.setState({ recaptchaReady: true });
      this.showWithCaptcha();
    } else {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${StringConstantsMixin.constants.GOOGLE_RECAPTCHA.SITE_KEY}`;
      script.async = true;
      script.onload = () => {
        grecaptcha.ready(() => {
          this.setState({ recaptchaReady: true });
          this.showWithCaptcha();
        });
      };
      document.body.appendChild(script);
    }
  },
  colorboxOptions(jQuery, recaptchaToken) {
    // Use the passed jQuery reference, not our local one, because it might be that of the containing window
    return {
      html: $('#map-download-modal-container').html(),
      width: '400px',
      height: '232px',
      onComplete: function() {
        jQuery('button.cancel').click(function() {
          jQuery.colorbox.close();
        });
        jQuery('button.ok').click(
          function() {
            jQuery.colorbox.close();
            const format = jQuery('#colorbox select#download')
              .children('option:selected')
              .val();
            _gaq.push(['_trackEvent', 'MapDownload', format, this.props.mapId ? 'Map' : 'Trail']);
            if (this.props.mapId) {
              window.location = `/maps/${this.props.mapId}/gpx?key=${ServerCommunicationUtil.apiKey}&format=${format}&recaptcha=${recaptchaToken}`;
            } else {
              window.location = `/${this.props.trailSlug}/gpx?ref=trail-more-gpx&format=${format}&recaptcha=${recaptchaToken}`;
            }
          }.bind(this)
        );
      }.bind(this)
    };
  },
  render() {
    const btnText = this.props.btnText || StringConstantsMixin.strings.TRACK_DETAIL.DOWNLOAD_ROUTE;
    // The rendered element here includes this hidden HTML #map-download-modal-container that we'll ask the colorbox to show
    const colorboxContents = (
      <div id="map-download-modal-container">
        <div id="map-download-modal" className="confirm-modal">
          <div className="modal-container">
            <div className="modal-header">
              <h3>{btnText}</h3>
            </div>
            <div className="modal-body" onClick={this.closeModal}>
              <p>{StringConstantsMixin.strings.TRACK_DETAIL.CHOOSE_FILE_FORMAT}</p>
              <select name="filetype" id="download" defaultValue="gpxTrk">
                <option value="gpxTrk">GPX Track</option>
                <option value="kml">Google Earth KML</option>
                <option value="tcx">Garmin Course TCX</option>
                <option value="crs">Garmin Course CRS</option>
                <option value="csv">CSV</option>
                <option value="fit">Garmin FIT (ANT+)</option>
                <option value="gpxRte">GPX Route</option>
                <option value="kmz">Google Earth KMZ</option>
                <option value="kmlGx">Google Earth Timeline</option>
                <option value="kmlTour">Google Earth Tour</option>
                <option value="ovl">OVL (ASCII)</option>
                <option value="fugawi">Fugawi</option>
                <option value="kompass">KOMPASS Verlag</option>
                <option value="pcx5Trk">PCX5 Track</option>
                <option value="geoRssTrk">GeoRSS Track</option>
                <option value="excel">MS Excel</option>
                <option value="oziExplorer">OziExplorer</option>
                <option value="ikt">MagicMaps IKT</option>
                <option value="falkTourRte">Falk IBEX Tour</option>
                <option value="geoJsonTrk">GeoJSON Track</option>
                <option value="jsonTrk">JSON Track</option>
                <option value="pwtrk">PathAway</option>
                <option value="navigon5Rte">Navigon RTE 5.x</option>
                <option value="navigon6Rte">Navigon RTE 6.x</option>
                <option value="freshroute">Navigon Freshroute</option>
                <option value="magellanTrk">Magellan Track</option>
                <option value="osynceTrk">o-synce Track</option>
                <option value="compeGpsTrk">CompeGPS Track</option>
                <option value="qpeGpsTrk">qpeGPS Track</option>
                <option value="tomTomRte">TomTom ITN</option>
                <option value="logbook">Garmin Logbook</option>
                <option value="sqlTrk">SQL Inserts Track</option>
                <option value="bddTdTrk">BDD (Bait dropping)</option>
              </select>
            </div>
            <div className="modal-footer">
              <div className="btn-group">
                <button className="cancel">{StringConstantsMixin.strings.CANCEL}</button>
                <button className="ok">{StringConstantsMixin.strings.TRACK_DETAIL.START_DOWNLOAD}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    if (this.props.styles) {
      return (
        <span>
          <div className={this.props.styles.dropdownItem}>
            <a className={this.props.styles.gpxLabel} onClick={this.showDownloadModal} onMouseEnter={this.props.onMouseEnter}>
              {btnText}
            </a>
          </div>
          {colorboxContents}
        </span>
      );
    }

    if (this.props.modalOnly) {
      return colorboxContents;
    }

    return (
      <span>
        <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
          <a onClick={this.showDownloadModal}>{btnText}</a>
        </span>
        {colorboxContents}
      </span>
    );
  }
});

MapDownloadButton.defaultProps = {
  setRemoteRef: null
};

export { MapDownloadButton };
